import { PropsWithChildren } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { tv } from 'tailwind-variants';

interface ErrorLabelProps extends PropsWithChildren {
  showIcon?: boolean;
  className?: string;
}

const container = tv({
  base: 'flex gap-2 items-center',
});

export default function ErrorLabel({ showIcon = true, className, children }: ErrorLabelProps) {
  return (
    <div className={container({ className })}>
      {showIcon && <FiAlertCircle className="text-support-error" />}
      <span className="text-support-error text-sm font-medium">{children}</span>
    </div>
  );
}
